import { render, staticRenderFns } from "./HolidaysTable.vue?vue&type=template&id=891c8bcc&scoped=true"
import script from "./HolidaysTable.vue?vue&type=script&lang=js"
export * from "./HolidaysTable.vue?vue&type=script&lang=js"
import style0 from "./HolidaysTable.vue?vue&type=style&index=0&id=891c8bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891c8bcc",
  null
  
)

export default component.exports